<template>
  <Card class="top">
    <div class="top__show">
      <Tabs
        v-model="type"
        @tab-click="handleTabClick"
      >
        <TabPane
          v-for="item in tabs"
          :key="item.key"
          :label="item.name"
          :name="item.key"
        />
      </Tabs>

      <!-- <RadioGroup
        v-model="dataDisplayType"
        @change="handleRadioChange"
      >
        <RadioButton label="1">表格展示</RadioButton>
        <RadioButton label="2">图表展示</RadioButton>
      </RadioGroup> -->
    </div>

    <div class="top__action">
      <Select
        v-model="index"
        class="top__field"
        @change="handleFieldChange"
      >
        <Option
          v-for="item in fields"
          :key="item.prop"
          :label="item.label"
          :value="item.prop"
        />
      </Select>

      <CheckboxGroup
        v-if="type === 'product'"
        v-model="subType"
        @change="handleCheckboxChange"
      >
        <Checkbox label="is_app_marketing_type">分营销场景</Checkbox>
        <Checkbox label="is_media">分媒体</Checkbox>
        <Checkbox label="is_adslot">分栏位</Checkbox>
      </CheckboxGroup>
    </div>

    <!-- v-if="dataDisplayType === '1'" -->
    <Table
      v-loading="tableLoading"
      class="top__table"
      height="540"
      border
      :data="tableData"
      :header-cell-style="tableHeaderStyle"
      :default-sort = "{prop: 'date_index', order: 'descending'}"
    >
      <TableColumn
        v-for="item in tableColumns"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :width="item.width"
        :sortable="item.sortable"
        align="right"
      >
        <template slot-scope="scope">
          {{ getValue(scope) }}
        </template>
      </TableColumn>
    </Table>
  </Card>
</template>

<script>
import {
  Card,
  Table,
  TableColumn,
  Tabs,
  TabPane,
  Select,
  Option,
  CheckboxGroup,
  Checkbox,
} from 'element-ui';

import fields from './fields';
import { getField } from '@/config/columns/';
import Request from '@/core/QuRequest';
import { createTopTableData } from '../utils/formatData';
import { formatValue } from '../utils/formatValue';

const req = new Request();

export default {
  components: {
    Card,
    Table,
    TableColumn,
    Tabs,
    TabPane,
    Select,
    Option,
    CheckboxGroup,
    Checkbox,
  },

  props: {
    date: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      type: 'agent',
      tabs: [
        {
          key: 'agent',
          name: 'TOP10代理商',
        },
        {
          key: 'product',
          name: 'TOP10产品（分营销场景、分媒体、分栏位）',
        },
      ],
      index: 'cost_total',
      fields,
      subType: [],
      tableData: [],
      tableLoading: false,
      startDate: '',
      endDate: '',
      columns: this.tableColumns,
    };
  },

  computed: {
    columnName() {
      return getField(this.index).name;
    },

    tableColumns() {
      let list = [
        {
          label: this.type === 'agent' ? '代理商ID' : '产品ID',
          prop: '_id',
          width: '100px',
          sortable: false,
        },
        {
          label: this.type === 'agent' ? '代理商名称' : '产品名称',
          prop: '_name',
          sortable: false,
        },
        {
          label: `${this.startDate} ${this.columnName}`,
          prop: 'date_index',
          sortable: true,
          width: '200px',
        },
        {
          label: `${this.endDate} ${this.columnName}`,
          prop: 'compare_date_index',
          sortable: true,
          width: '200px',
        },
        {
          label: '涨幅',
          prop: 'add',
          width: '120px',
          sortable: true,
        },
        {
          label: '涨幅百分比',
          prop: 'add-rate',
          width: '120px',
          sortable: true,
        },
      ];

      if (this.type === 'product') {
        if (this.subType.includes('is_media')) {
          list.splice(2, 0, {
            label: '媒体',
            prop: 'media_type',
            sortable: false,
            width: '100px',
          });
        } else {
          list = list.filter((item) => {
            return item.prop !== 'media_type';
          });
        }

        if (this.subType.includes('is_adslot')) {
          const current = list[2];
          const start = current.label === 'media_type' ? 3 : 2;
          list.splice(start, 0, {
            label: '栏位',
            prop: 'adslot_type',
            sortable: false,
            width: '150px',
          });
        } else {
          list = list.filter((item) => {
            return item.prop !== 'adslot_type';
          });
        }
        if (this.subType.includes('is_app_marketing_type')) {
          list.splice(2, 0, {
            label: '营销场景',
            prop: 'app_marketing_type',
            sortable: false,
            width: '100px',
          });
        } else {
          list = list.filter((item) => {
            return item.prop !== 'app_marketing_type';
          });
        }
      }

      return list;
    },
  },

  created() {
    this.volatilityTopAgentDetail();
  },

  methods: {
    updateData() {
      if (this.type === 'agent') {
        this.volatilityTopAgentDetail();
      } else if (this.type === 'product') {
        this.volatilityTopProductDetail();
      }
    },

    getValue(scope) {
      const key = scope.column.property;
      const value = scope.row[key];
      const convertKeys = ['date_index', 'compare_date_index', 'add'];
      if (convertKeys.includes(key)) {
        return formatValue(this.index, value);
      } else if (key === 'add-rate') {
        return `${value}%`;
      } else {
        return value;
      }
    },

    async volatilityTopAgentDetail() {
      this.tableLoading = true;
      try {
        const params = {
          date: this.date[0].format('YYYY-MM-DD'),
          compare_date: this.date[1].format('YYYY-MM-DD'),
          index: this.index,
        };
        const res = await req.send(
          req.Apis.sales.report.volatilityTopAgentDetail,
          params,
        );

        this.tableLoading = false;

        if (res && res.code === 200) {
          this.tableData = createTopTableData(res.data.list);
          this.startDate = res.data.date;
          this.endDate = res.data.compare_date;
        }
      } catch (err) {
        this.tableLoading = false;
        this.$message.error(err.message);
      }
    },

    async volatilityTopProductDetail() {
      this.tableLoading = true;
      try {
        const params = {
          date: this.date[0].format('YYYY-MM-DD'),
          compare_date: this.date[1].format('YYYY-MM-DD'),
          index: this.index,
          is_app_marketing_type: Number(
            this.subType.includes('is_app_marketing_type'),
          ),
          is_media: this.subType.includes('is_media') ? 1 : 0,
          is_adslot: this.subType.includes('is_adslot') ? 1 : 0,
        };

        const res = await req.send(
          req.Apis.sales.report.volatilityTopProductDetail,
          params,
        );

        this.tableLoading = false;

        if (res && res.code === 200) {
          this.tableData = createTopTableData(res.data.list);
          this.startDate = res.data.date;
          this.endDate = res.data.compare_date;
        }
      } catch (err) {
        this.tableLoading = false;
        this.$message.error(err.message);
      }
    },

    tableHeaderStyle({ rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #F2F9FF';
      }
    },

    handleTabClick() {
      this.updateData();
    },

    handleFieldChange() {
      this.updateData();
    },

    handleCheckboxChange() {
      this.updateData();
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  margin-top: 24px;

  &__show {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__action {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__field {
    margin-top: 12px;
  }

  &__table {
    margin-top: 24px;
  }

  &__rate {
    font-size: 14px;
    font-weight: 400;
    color: rgba(48, 49, 51, 1);
    margin-top: 24px;

    &--icon {
      margin-left: 6px;
      cursor: pointer;
    }
  }
}
</style>